import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'src/app/services/toastr.service';

@Component({
  selector: 'app-toastr',
  templateUrl: './toastr.component.html',
  styleUrls: ['./toastr.component.css'],
  host: { class: 'toast-container position-fixed p-3', style: 'z-index: 1200;  top: 15px; right: 20px;' },
})
export class ToastrComponent {

  constructor(
    public toastService: ToastrService
  ) { }
}
